/*global TTApplicationEnum, GetAppInfo, _moovilaSecurity */
/*eslint no-undef: "error"*/

import { v2Api } from 'moovila-common';
import * as types from '../constants/ActionTypes';
import { toastr } from 'react-redux-toastr';
import axios from "axios";

const defaultFailedCallback = () => {
  // i can't think of nothin -Black Francis
}

const thereWasAnError = () => {
  toastr.info('', 'Sorry, there was an error saving your last action.');
}

export const isLoading = isLoading => ({ type: types.LOADING, isLoading });

export const resetLoading = () => ({ type: types.RESET_LOADING });

export const waitForPermissionsAndPurge = () => (dispatch) => {
  if (!_moovilaSecurity.CurrentSession().PermissionInfo.userGUID) {
    // loop until we have our response
    setTimeout(function() { dispatch(waitForPermissionsAndPurge()) }, 200);
    return;
  }
  // now that we have permissions, let's check to see if the user should be here at all
  const permissions = _moovilaSecurity.CurrentSession().PermissionInfo;
  if (!permissions.isAdmin && !permissions.PermissionList.length) {
    dispatch({
      type: types.LOGIN,
      isLoggedIn: {
        title: 'Login Failed',
        message: 'Invalid login or password. Please re-login.',
        success: false,
        isLoggedIn: false,
      },
    });
  }
  dispatch({ type: types.LOADING, isLoading: false });
}

export const login = (username, password) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  console.log('MoM: trying to login...');
  return v2Api
    // username, password, isInternalAdmin, originClientApp (MoM = 5)
    .login(username, password, true, 5)
    .then((loggedIn) => {
      const isLoggedIn = loggedIn.success ? {
        userGUID: loggedIn.userGUID,
        login: loggedIn.userEmailAddress,
        isLoggedIn: true,
      } : loggedIn;
      dispatch({
        type: types.LOGIN,
        isLoggedIn,
      });
      if (loggedIn.success && !_moovilaSecurity.CurrentSession().PermissionInfo.userGUID) {
        dispatch({ type: types.LOADING, isLoading: true });
        dispatch(waitForPermissionsAndPurge());
      }
      dispatch({ type: types.LOADING, isLoading: false });
    });
};

export const logout = () => {
  v2Api.logout();
  return {
    type: types.LOGIN,
    isLoggedIn: false,
  }
};

export const clearLoginFailed = () => {
  return {
    type: types.CLEAR_LOGIN_FAILED,
  }
}

export const resetPassword = (email) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('User/ResetPassword', { userEmailAddress: email })
    .then(({data, additionalInfo}) => {
      dispatch({
        type: types.RECEIVE_RESET_PASSWORD,
        resetPasswordStatus: additionalInfo.status,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const clearPasswordReset = () => ({
  type: types.CLEAR_PASSWORD_RESET,
});

export const checkSession = (sessionGUID, enterpriseGUID, failedCallback = defaultFailedCallback) => (dispatch) => {
  return v2Api
    .checkSession(sessionGUID, enterpriseGUID)
    .then((loggedIn) => {
      const currentSession = v2Api.getCurrentSession();
      let isLoggedIn = false;
      if (currentSession && currentSession.SessionInfo) {
        isLoggedIn = currentSession;
        dispatch({
          type: types.LOGIN,
          isLoggedIn: {
            userGUID: isLoggedIn.UserInfo.userGUID,
            login: isLoggedIn.UserInfo.userEmailAddress,
            isLoggedIn: true,
          },
        });
      } else {
        const isLoggedIn = sessionGUID ? {
          success: false,
          title: 'Login Failed',
          message: 'Invalid login or passwords. Please re-login.',
        } : { success: false };
        dispatch({
          type: types.LOGIN,
          isLoggedIn,
        });
      }
      // dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const showMessageBox = ({ title, message }) => {
  return ({
    type: types.SHOW_MESSAGE_BOX,
    title,
    message,
  })
};

export const clearMessageBox = () => ({
  type: types.CLEAR_MESSAGE_BOX,
});

export const setQuestion = questionObject => ({
  type: types.SET_QUESTION,
  questionObject,
});

export const resetQuestion = () => ({ type: types.RESET_QUESTION });

export const getGeneralInfo = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Util/GetAPIInfo', null)
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_GENERAL_INFO,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
};

export const getAPIMethods = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Util/GetAPIDictionary', null)
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_API_METHODS,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const calculateTaskRepeat = (taskGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Util/CalculateRepeatFromTaskGUID', { taskGUID })
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_CALCULATED_TASK_REPEAT,
        data,
        taskGUID,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    }); 
}

export const clearRepeats = () => ({ type: types.CLEAR_REPEATS });

export const getTaskInfo = (taskGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Task/GetTaskInfo', { taskGUID })
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_TASK_INFO,
        data,
        taskGUID,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    }); 
}

export const getEnterpriseList = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Enterprise/GetEnterpriseList', null)
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_ENTERPRISE_LIST,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    })
}

export const getEnterpriseInfo = (enterpriseGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Enterprise/GetEnterpriseInfo', {enterpriseGUID})
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_ENTERPRISE_INFO,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    })
}

export const clearEnterpriseInfo = () => ({
  type: types.CLEAR_ENTERPRISE_INFO,
});

export const addEnterprise = (enterpriseData) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Enterprise/AddEnterpriseInfo', { ...enterpriseData })
    .then(() => {
      dispatch(getEnterpriseList());
      dispatch({ type: types.LOADING, isLoading: false });
    })
    .catch((errCode, errMessage) => {
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in updateEnterpriseInfo. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const updateEnterpriseInfo = (enterpriseData) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Enterprise/UpdateEnterpriseInfo', { ...enterpriseData })
    .then(() => {
      dispatch(getEnterpriseList());
      dispatch({ type: types.LOADING, isLoading: false });
    })
    .catch((errCode, errMessage) => {
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in updateEnterpriseInfo. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const getEnterpriseRoles = (enterpriseGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetRoleList', {enterpriseGUID})
    .then((res) => {
      dispatch({
        type: types.RECEIVE_ENTERPRISE_ROLES,
        data: res.data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
};

export const getEnterpriseUsers = (enterpriseGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('User/GetUserList', { enterpriseGUID, includeAll: true })
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_ENTERPRISE_USERS,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const getImpersonatedUsers = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetImpersonationListForUser', {})
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_IMPERSONATED_USERS,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const clearEnterpriseUsers = () => ({
  type: types.CLEAR_ENTERPRISE_USERS,
});

export const updateEnterpriseDomains = (enterpriseGUID, enterpriseDomain) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Enterprise/UpdateEnterpriseDomainInfo', { enterpriseGUID, enterpriseDomain })
    .then(() => {
      dispatch(getEnterpriseInfo(enterpriseGUID));
      dispatch({ type: types.LOADING, isLoading: false });
    })
    .catch((errCode, errMessage) => {
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in updateEnterpriseDomains. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const deleteEnterpriseDomain = (enterpriseGUID, enterpriseDomainID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
  .fetch('Enterprise/DeleteEnterpriseDomain', { enterpriseGUID, enterpriseDomainID })
  .then(() => {
    dispatch(getEnterpriseInfo(enterpriseGUID));
    dispatch({ type: types.LOADING, isLoading: false });
  })
  .catch((errCode, errMessage) => {
    thereWasAnError();
    dispatch({type: types.RESET_LOADING});
    console.error('Error in deleteEnterpriseDomain. The request could not be completed.');
    dispatch({ type: types.LOADING, isLoading: false });
  });
}

export const getUserInfo = (userGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('User/GetUserInfo', { userGUID })
    .then(({data}) => {
      dispatch({
        type: types.RECEIVE_USER_INFO,
        data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const updateUser = (user, prevState, add=false) => (dispatch) => {
  dispatch({
    type: types.UPDATE_USER,
    user,
  });
  return v2Api
    .fetch('User/UpdateUserInfo', user)
    .then(() => dispatch(getEnterpriseUsers(user.enterpriseGUID)))
    .catch((errCode, errMessage) => {
      // dispatch({
      //   type: types.ERROR_UPDATE_USER,
      //   prevState
      // });
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in updateUser. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
    });
};

export const inviteUser = (userGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('User/InviteUser', {invitedUserGUID: userGUID})
    .then((res) => {
      dispatch ({
        type: types.INVITE_USER,
        userGUID,
        userVerificationCode: res.data.userVerificationCode,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const stageUserForDelete = (userGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('User/CheckForUserActivity', {userGUID})
    .then((res) => {
      dispatch ({
        type: types.STAGE_USER_FOR_DELETE,
        userGUID,
        isClearedForDelete: !res.data.hasActivity,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const unstageUsersForDelete = () => ({ type: types.UNSTAGE_USERS_FOR_DELETE });

export const deleteUser = (userGUID, emailAddress, prevState) => (dispatch) => {
  dispatch({
    type: types.DELETE_USER,
    userGUID,
  });

  return v2Api
    .fetch('User/DeleteUser', { userGUID, emailAddress })
    .then(() => {}) // callback noop -- we need to fire a toast here or something
    .catch((errCode, errMessage) => { // error handler
      dispatch({
        type: types.ERROR_DELETE_USER,
        prevState
      });
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in deleteUser. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const getRoles = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetRoleList', null)
    .then((res) => {
      dispatch({
        type: types.RECEIVE_ROLES,
        payload: res.data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
};

export const getPermissions = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetPermissionsList', null)
    .then((data) => {
      dispatch({
        type: types.RECEIVE_PERMISSIONS,
        payload: data.data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
};

export const getLicenseList = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.get(baseUrl + '/Licensing/License/List', {

      'headers': { 'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((res) =>{ 
      dispatch({
        type: types.RECEIVE_LICENSES,
        payload: res.data,
      })
      dispatch({ type: types.LOADING, isLoading: false });
      return res.data;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const getFeaturesList = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetFeaturesList', null)
    .then((data) => {
      dispatch({
        type: types.RECEIVE_FEATURES,
        payload: data.data,
      });
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const getPermissionList = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.get(baseUrl + '​/Permissions/GetList', {

      'headers': { 'Authorization': `Bearer ${jwt}`,
                   
      }
    }).then((res) =>{ 
      dispatch({
        type: types.RECEIVE_FEATURES,
        payload: res.data,
      })
      dispatch({ type: types.LOADING, isLoading: false });
      return res.data;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const updateLicense = (license) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.post(baseUrl + '/Licensing/License',
      license,
      {
      'headers': { 'Authorization': `Bearer ${jwt}`,
      }
    }).then((res) =>{ 
      dispatch(getLicenseList());
      dispatch({ type: types.LOADING, isLoading: false });
      return res;
    }).catch((error) => {
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in updateLicense. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
      console.log(error.request);
    });
  });
}

export const deleteLicense = (licenseGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.delete(baseUrl + '/Licensing/License', {
      params: {
        licenseGUID: licenseGUID
      },
      'headers': { 'Authorization': `Bearer ${jwt}`,
      'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((res) =>{ 
      dispatch(getLicenseList());
      dispatch({ type: types.LOADING, isLoading: false });
      return res;
    }).catch((error) => {
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in deleteLicense. The request could not be completed.');
      dispatch({ type: types.LOADING, isLoading: false });
      console.log(error.request);
    });
  });
}

export const getEnterpriseLicenseList = (enterpriseGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.get(baseUrl + '/Licensing/Enterprise', {
      params: {
        enterpriseGUID: enterpriseGUID
      },
      'headers': { 'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((res) =>{ 
      dispatch({
        type: types.RECEIVE_ENTERPRISE_LICENSE_ASSIGNMENTS,
        payload: res.data.licenses,
      })
      dispatch({ type: types.LOADING, isLoading: false });
      return res.data.licenses;
    }).catch((error) => {
      console.log(error.request);
    });
  });

}

export const getUserLicenseList = (userGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.get(baseUrl + '/Licensing/User', {
      params: {
        userGUID: userGUID
      },
      'headers': { 'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((res) =>{ 
      dispatch({
        type: types.RECEIVE_USER_LICENSE_ASSIGNMENTS,
        payload: res.data.licenses,
      })
      dispatch({ type: types.LOADING, isLoading: false });
      return res.data.licenses;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const updateUserLicenseAssignment = (assignments) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.post(baseUrl + '/Licensing/User',
        assignments,
      {
      'headers': { 'Authorization': `Bearer ${jwt}`,
      }
    }).then((res) =>{ 
      dispatch(getUserLicenseList(assignments.userGUID));
      dispatch({ type: types.LOADING, isLoading: false });
      return res;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const deleteUserLicenseAssignment = (assignments) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.post(baseUrl + '/Licensing/User',
        assignments,
      {
      'headers': { 'Authorization': `Bearer ${jwt}`,
      }
    }).then((res) =>{ 
      dispatch(getUserLicenseList(assignments.userGUID));
      dispatch({ type: types.LOADING, isLoading: false });
      return res;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const updateLicenseAssignment = (assignments) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.post(baseUrl + '/Licensing/Enterprise',
        assignments,
      {
      'headers': { 'Authorization': `Bearer ${jwt}`,
      }
    }).then((res) =>{ 
      dispatch(getEnterpriseLicenseList(assignments.enterpriseGUID));
      dispatch({ type: types.LOADING, isLoading: false });
      return res;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const deleteLicenseAssignment = (assignments) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  const app = GetAppInfo(TTApplicationEnum.API);
  const baseUrl = app.siteURL;
  return _moovilaSecurity.GetJWTToken((jwt) => {
    return axios.post(baseUrl + '/Licensing/Enterprise',
        assignments
      ,
      {
      'headers': { 'Authorization': `Bearer ${jwt}`,
      }
    }).then((res) =>{ 
      dispatch(getEnterpriseLicenseList(assignments.enterpriseGUID));
      dispatch({ type: types.LOADING, isLoading: false });
      return res;
    }).catch((error) => {
      console.log(error.request);
    });
  });
}

export const getLicenseAssignmentList = (licenseGUID) => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetLicenseAssignmentList', {licenseGUID})
    .then((data) => {
      dispatch({
        type: types.RECEIVE_LICENSE_ASSIGNMENT_LIST,
        payload: data.data,
      })
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const getDefaultPasswordConfiguration = () => (dispatch) => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('Security/GetDefaultPasswordConfiguration', null)
    .then((data) => {
      dispatch({
        type: types.RECEIVE_DEFAULT_PASSWORD_CONFIGURATION,
        payload: data.data,
      })
      dispatch({ type: types.LOADING, isLoading: false });
    });
}

export const changeUserEnterprise = (userGUID, enterpriseGUID, oldEnterpriseGUID) => dispatch => {
  dispatch({ type: types.LOADING, isLoading: true });
  return v2Api
    .fetch('User/ChangeUserEnterprise', {userGUID, enterpriseGUID})
    .then(() => {
      toastr.success('', 'User transferred to new enterprise.');
      dispatch({ type: types.LOADING, isLoading: false });
      dispatch(getEnterpriseUsers(oldEnterpriseGUID));
    })
    .catch((errCode, errMessage) => {
      thereWasAnError();
      dispatch({type: types.RESET_LOADING});
      console.error('Error in changeUserEnterprise. The request could not be completed.');
    });
}



// WEBPACK FOOTER //
// ./src/actions/index.js